import { stopper } from '@/kenwood/Controllers/Listing/KenwoodListingBackToPlpController';
import { isTrue } from '@/utils/Common/Booleans';
import EVENTS from '@/utils/Constants/Events';
import GTM from '@/utils/Controllers/GTM/Constants';
import { emitGtmListingImpression } from '@/utils/Controllers/GTM/Operations/ListingImpression';
import { updateProductsPositionForGTMListing } from '@/utils/Controllers/GTM/Utils';

const observerConfig = { rootMargin: '0px 0px 200px 0px' };
const SHARED_LOADER_MORE_CTA_ID = 'js-listing-load-more';
const SHARED_PAGE_LIMIT_ID = 'js-listing-page-limit';
export const SHARED_RESULTS_WRAPPER_ID = 'js-listing__results-wrapper';
const SHARED_PRODUCT_TILE_WRAPPER_SELECTOR = '.js-listing__productTile';

const updatePagination = (nextPage, gtmEvent) => {
  DLG.EVE.emit(EVENTS.LISTING.RESULTS.PAGINATION, { nextPage, gtmEvent });
};

const loadMoreClickHandler = e => {
  const { nextPage } = e.currentTarget.dataset;
  updatePagination(nextPage, GTM.EVENT.LISTING_IMPRESSION_LOAD_MORE);
};

const loadMoreResults = () => {
  const el = document.getElementById(SHARED_LOADER_MORE_CTA_ID);
  if (el) {
    el.addEventListener('click', loadMoreClickHandler);
  }
};

const observerHandler = entries => {
  const entry = entries[0];
  const { nextPage } = entry.target.dataset;
  if (entry.isIntersecting && !stopper) {
    updatePagination(nextPage, GTM.EVENT.LISTING_IMPRESSION_SCROLL);
  }
};

const saveCoords = targetProduct => {
  const element = document.getElementById(`prod-id-${targetProduct}`);
  const attribute = element.getAttribute('data-pagination');
  sessionStorage.setItem(
    'anchor',
    JSON.stringify({
      page: attribute,
      code: targetProduct,
    }),
  );
};

const infiniteScrollResults = () => {
  const uniqueCardValue = document.getElementsByClassName('uniqueProductValue');
  const productCard = document.getElementsByClassName('js-product-tile');
  const inputsValue = [];

  for (let j = 0; j < uniqueCardValue.length; j += 1) {
    inputsValue.push(uniqueCardValue[j].value);
  }

  for (let i = 0; i < productCard.length; i += 1) {
    productCard[i].addEventListener('click', () => {
      saveCoords(inputsValue[i]);
    });
  }

  const el = document.getElementById(SHARED_PAGE_LIMIT_ID);
  if (el && !isTrue(el.dataset.hasLoadMore)) {
    const observer = new IntersectionObserver(observerHandler, observerConfig);
    observer.observe(el);
  }
};

const bindCommonEventsOnPage = bindBrandEventsOnPage => {
  infiniteScrollResults();
  loadMoreResults();
  bindBrandEventsOnPage();
  document
    .getElementById(SHARED_RESULTS_WRAPPER_ID)
    .querySelectorAll('a,button,[tabindex]')
    .forEach(tileFocusableElement => {
      tileFocusableElement.addEventListener('focus', e => {
        document
          .querySelectorAll('.js-product-tile.hover')
          .forEach(tile => tile.classList.remove('hover'));
        e.target.closest('.js-product-tile').classList.add('hover');
      });
    });
  DLG.EVE.emit(EVENTS.LISTING.COMPARE.UPDATE);
};

const defaultUpdateResults = (html, bindBrandEventsOnPage) => {
  const el = document.getElementById(SHARED_RESULTS_WRAPPER_ID);
  const children = document.querySelectorAll(
    SHARED_PRODUCT_TILE_WRAPPER_SELECTOR,
  );
  Array.from(children).forEach(child => el.removeChild(child));
  el.innerHTML = html;
  emitGtmListingImpression();
  bindCommonEventsOnPage(bindBrandEventsOnPage);
};

const defaultAppendResults = (
  { html, gtmEvent = null, lastPage },
  bindBrandEventsOnPage,
) => {
  const el = document.getElementById(SHARED_RESULTS_WRAPPER_ID);
  const listingLimitEl = document.getElementById(SHARED_PAGE_LIMIT_ID);
  listingLimitEl.insertAdjacentHTML('beforebegin', html);
  el.removeChild(listingLimitEl);
  bindCommonEventsOnPage(bindBrandEventsOnPage);
  if (gtmEvent) {
    updateProductsPositionForGTMListing();
    emitGtmListingImpression(gtmEvent);
  }
  DLG.EVE.emit(EVENTS.LISTING.RESULTS.PAGEUPDATE, lastPage);
};

export default ({
  updateResults = defaultUpdateResults,
  appendResults = defaultAppendResults,
  bindBrandEventsOnPage = () => {},
}) => {
  DLG.EVE.on(EVENTS.LISTING.RESULTS.UPDATE, res =>
    updateResults(res, bindBrandEventsOnPage),
  );
  DLG.EVE.on(EVENTS.LISTING.RESULTS.APPEND, res =>
    appendResults(res, bindBrandEventsOnPage),
  );
  infiniteScrollResults();
  loadMoreResults();
};
